import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAvailableColumnsService, getAvailableColumnsPpr } from './api';

export const path = '/logs';

const PageLogs: React.FC = (props) => {
  const Logs = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columnsService: getAvailableColumnsService,
      columnsPpr: getAvailableColumnsPpr,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Logs {...props} />;
};

export default PageLogs;
